import { ApolloClient, InMemoryCache, from, type NormalizedCacheObject } from '@apollo/client';
import { authLink, idpHttpLink } from '@/lib/apollo/link';

let idpClient: ApolloClient<NormalizedCacheObject> | undefined;

export const getIdpApolloClient = () => {
  if (!idpClient) {
    idpClient = new ApolloClient({
      cache: new InMemoryCache(),
      // 直接 idp.klew.jp を叩くため、IAP トークンを authLink で付与する。
      // cookieHeader はブラウザでは不要（credentials: 'include' が Cookie を載せる）。
      link: from([authLink(undefined, 'idp'), idpHttpLink]),
      defaultOptions: {
        query: {
          fetchPolicy: 'network-only',
        },
      },
    });
  }
  return idpClient;
};
